import { render, staticRenderFns } from "./speechIcon.vue?vue&type=template&id=2033520b&scoped=true"
import script from "./speechIcon.vue?vue&type=script&lang=js"
export * from "./speechIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2033520b",
  null
  
)

export default component.exports